module.exports = "/_next/static/images/top-26b19920a48e5330eb0f7574292dc080.jpg";